//Required Module imports//
import React, { Component } from 'react';
import {
  Button,
  // Popconfirm,
  Input
} from 'antd';
import {
  // DeleteOutlined,
  EditOutlined,
  // QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { createStructuredSelector } from 'reselect';
import { getUserProfile } from '../../../../../selectors/layout';
import { getTranslationCache } from '../../../../../selectors/language';
import { connect } from 'react-redux';
import Tooltip from 'antd/es/tooltip';

//Required Component imports//
import {
  getDeviceTypeList,
  //getTagsByEquipmentTypeId,
  deleteDeviceType
} from '../../../Utils/FormCalls';
//css//
import { StyledComponent } from '../../../CSS/style';
import ListView from '../../../Utils/ListView';
import themeSettings from '../../../Utils/themeSettings.json';
import { constant } from '../../../Utils/constants';
import Highlighter from 'react-highlight-words';
import translation from '../../../Utils/translation';
import { encode as base64_encode } from 'base-64';
import history from '../../../../../commons/history';

//const variables//
// const urlList = {
//   list: '/api/deviceType/list',
//   getbyId: '/api/masterTool/getById'
// };

class EquipmentTagList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      activeKey: '1',
      form: {},
      userProfile: props && props.userProfile ? props.userProfile : {},
      userList: [],
      translationCache: props.translationCache || [],
      config: {
        viewTypes: ['add', 'card', 'table'],
        defaultViewType: 'table',

        filterType: 'ByAttributeValue',
        TitleView: true,
        attributeList: ['Name', 'Description'],

        firstTitle: 'Name',
        secondTitle: 'Code',
        thirdTitle: 'Description',
        actions: ['edit'],
        // actions: ['edit', 'delete'],
        edit: {
          byAttribute: 'Code',
          redirectURL: '/rubus/AMM/EquipmentTagDetails'
        },
        deletee: {
          byAttribute: 'Id'
        }
      }
    };
  }
  componentDidUpdate(prevprops) {
    if (this.props.match.params.Masters !== prevprops.match.params.Masters) {
      let mastername = this.props.match.params.Masters;
      this._getAdhocDataSource();
      this.setState({ mastername });
    }
    if (prevprops.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
  }
  componentDidMount = async () => {
    this._getAdhocDataSource();
  };

  _getAdhocDataSource = async () => {
    let dataSource = await getDeviceTypeList();
    this.setState({
      dataSource,
      activeKey: '1',
      form: {}
    });
  };

  downTimeData = (form) => {
    this.setState({
      form
    });
  };

  deteteEquipmentType = async (record) => {
    await deleteDeviceType(record.Id);
    let dataSource = await getDeviceTypeList();
    this.setState({
      dataSource,
      activeKey: '1'
      // form: {}
    });
  };

  _editRecord = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  // editMaster = async (tableRowData) => {
  //   let { form } = this.state;
  //   let data = await getTagsByEquipmentTypeId(tableRowData.Code);
  //   form = {
  //     ...tableRowData,
  //     Tags: [...data]
  //   };
  //   // let datasource = data.Specifications[0]
  //   this.setState({
  //     activeKey: '2',
  //     form
  //     // datasource: data.Specifications
  //   });
  // };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(this.props.transaltionCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(this.props.transaltionCache, 'Search')}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {translation(this.props.transaltionCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };

  render() {
    const { dataSource, userList } = this.state;
    let { translationCache } = this.props;
    let columns = [
      {
        title: translation(translationCache, constant.equipmentTypeName),
        dataIndex: 'Name',
        key: 'Name',
        ...this.getColumnSearchProps('Name')
      },
      {
        title: translation(translationCache, constant.equipmentTypeCode),
        dataIndex: 'Code',
        key: 'Code'
      },
      {
        title: translation(translationCache, constant.equipmentTypeDescription),
        dataIndex: 'Description',
        key: 'Description',
        ...this.getColumnSearchProps('Description')
      },
      {
        title: translation(translationCache, constant.action),
        width: '600',
        render: (text, record) => (
          <>
            <Button className="ant-btn" onClick={() => this._editRecord(record)} size="middle">
              <Tooltip title={translation(translationCache, 'Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
            {/* <Popconfirm
              title={translation(
                this.props.translationCache,
                'Are you sure that you want to delete the EquipmentTags Master'
              )}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this.deteteEquipmentType(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button className="ant-btn" size="middle">
                <span style={{ color: '#ff4d4f' }}>
                  {' '}
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm> */}
          </>
        )
      }
    ];
    let config = {
      title: translation(translationCache, constant.EQUIPMENT_TAGS),

      viewTypes: ['add', 'card', 'table'],
      defaultViewType: 'table',

      filterType: 'ByAttributeValue',
      TitleView: true,
      attributeList: ['Name', 'Code', 'Description'],

      firstTitle: 'Name',
      secondTitle: 'Code',
      thirdTitle: 'Description',

      actions: ['edit'],
      edit: {
        byAttribute: 'Code',
        redirectURL: '/rubus/AMM/EquipmentTagDetails'
      },
      deletee: {
        byAttribute: 'Id'
      }
    };
    return (
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 143 }}>
        <ListView
          columns={columns}
          dataSource={dataSource}
          userList={userList}
          config={config}
          delete={this._deleteById}
        />
      </StyledComponent>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  userProfile: getUserProfile(),
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(EquipmentTagList);
